<template>
  <div class="real-times">
   

    <div class="topview" id="top">
      <span :class="[active == 1 ? 'active' : '']" @click="selectClick(1)">异常订单</span>
      <span>|</span>
      <span :class="[active == 2 ? 'active' : '']" @click="selectClick(2)">枪心跳日志</span>
      <span>|</span>
      <span :class="[active == 3 ? 'active' : '']" @click="selectClick(3)">edge心跳日志</span>
      <span>|</span>
      <span :class="[active == 4 ? 'active' : '']" @click="selectClick(4)">启停日志</span>
      <span>|</span>
      <span :class="[active == 5 ? 'active' : '']" @click="selectClick(5)">扣款日志</span>
      <span>|</span>
      <span :class="[active == 6 ? 'active' : '']" @click="selectClick(6)">签约日志</span>
      <span>|</span>
      <span :class="[active == 7 ? 'active' : '']" @click="selectClick(7)">硬件告警</span>
      <span>|</span>
      <span :class="[active == 8 ? 'active' : '']" @click="selectClick(8)">故障报修</span>
    </div>
      
    <div class="bottomviewone">
      <div v-if="active == 1">
        <abnormalOrder></abnormalOrder>
      </div>
      <div v-else-if="active == 2">
        <heartbeatLog></heartbeatLog>
      </div>
      <div v-else-if="active == 3">
        <edgeHeartbeatLog></edgeHeartbeatLog>
      </div>
      <div v-else-if="active == 4">
        <startorstopLog></startorstopLog>
      </div>
      <div v-else-if="active == 5">
        <cutmoneyLog></cutmoneyLog>
        <!-- <cutmoneyLog :message="clientwidth"></cutmoneyLog> -->
      </div>
      <div v-else-if="active == 6">
        <signedLog></signedLog>
      </div>
      <div v-else-if="active == 7">
        <hardwareLog></hardwareLog>
      </div>
      <div v-else-if="active == 8">
        <faultLog></faultLog>
      </div>
    </div>

  </div>
</template>

<script>
import abnormalOrder from "./abnormalOrder.vue";
import heartbeatLog from "./heartbeatLog.vue";
import edgeHeartbeatLog from "./edgeHeartbeatLog.vue";
import startorstopLog from "./startorstopLog.vue";
import cutmoneyLog from "./cutmoneyLog.vue";
import signedLog from "./signedLog.vue";
import hardwareLog from "./hardwareLog.vue";
import faultLog from "./faultLog.vue";


export default {
  data() {
    return {
      clientwidth:'',
      active:1,
      activeKey: "0",
      provinceList1:[],

    };
    
  },
  components:{
    abnormalOrder,
    heartbeatLog,
    edgeHeartbeatLog,
    startorstopLog,
    cutmoneyLog,
    signedLog,
    hardwareLog,
    faultLog,
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-color:#f8f8f8");
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  mounted(){
    let topview = document.getElementById("top");
    let clientwidth = topview.clientWidth||topview.offsetWidth;
    this.clientwidth = clientwidth - 30 + 'px';
    // console.log("宽度---：",this.clientwidth)
    this.active=this.$store.state.alarmNum?this.$store.state.alarmNum:1
   
  },
  watch:{
    clientwidth(val){
      // console.log("val-----:",val)
      this.clientwidth = val;
    }
  },
  methods:{

    selectClick(n){
      this.active = n;
      this.$store.commit('AlarmNum', n)
    },
  }
};
</script>

<style scoped lang="scss">

.real-times{
  margin: 1%;
}

.topview {
  
  height: 46px;
  
  background-color: white;
  text-align: left;
  margin-top: 1%;
  span {
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    margin-left: 20px;
    line-height: 46px;
    font-weight: bold;
  }
  span.active{
    color: #0071bd;
  }
}
.bottomviewone{
  margin-top: 15px;
}


// h1,
// h2 {
//   font-weight: normal;
//   color: #fff;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
</style>



// WEBPACK FOOTER //
// src/components/operationManagement/alarmManagement.vue